import React from "react";
import format from "date-fns/format";
import parseISO from "date-fns/parseISO";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import keyBy from "lodash/keyBy";
// import { useAppContext } from "../api/AppContext";

const getByWhomString = (by) => {
  if (by.firstName && by.lastName) {
    return ` by ${by.firstName} ${by.lastName} (${by.email})`;
  }
  if (by.email) {
    return ` by ${by.email}`;
  }
  return "";
};

const Timestamps = ({
  createdAt,
  updatedAt,
  createdBy,
  updatedBy,
  copiedFromJourneyId,
  locale,
  journeys,
  copiedFromEntity,
  copiedFromEntityId,
  dateFormat = "dd MMMM yyyy HH:mm:ss",
  isIso = false,
}) => {
  const journeysById = keyBy(journeys, "id");
  // const { user } = useAppContext();
  return (
    <>
      {createdAt && (
        <Grid item xs={12}>
          <Typography color="textSecondary" variant="caption">
            Created at{" "}
            {isIso
              ? format(parseISO(createdAt), dateFormat)
              : format(new Date(createdAt * 1000), dateFormat)}{" "}
            {createdBy && getByWhomString(createdBy)}
            {copiedFromJourneyId && journeysById[copiedFromJourneyId] && (
              <>
                {copiedFromJourneyId && ` copied from `}
                {copiedFromJourneyId && (
                  <a
                    href={`/journeys/${copiedFromJourneyId}/${locale}${
                      copiedFromEntity && copiedFromEntityId
                        ? `/${copiedFromEntity}s/${copiedFromEntityId}`
                        : ""
                    }`}
                    rel="noreferrer noopener"
                    target="_blank"
                  >
                    {journeysById[copiedFromJourneyId]?.internalName ||
                      journeysById[copiedFromJourneyId]?.name ||
                      `source ${copiedFromEntity}`}
                  </a>
                )}
              </>
            )}
            {copiedFromJourneyId && journeysById[copiedFromJourneyId] && (
              <>
                <i>Originally copied from another journey</i>
              </>
            )}
          </Typography>
        </Grid>
      )}
      {updatedAt && (
        <Grid item xs={12}>
          <Typography color="textSecondary" variant="caption">
            Last updated at{" "}
            {isIso
              ? format(parseISO(updatedAt), dateFormat)
              : format(new Date(updatedAt * 1000), dateFormat)}
            {updatedBy && getByWhomString(updatedBy)}
          </Typography>
        </Grid>
      )}
    </>
  );
};

export default Timestamps;
